import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {createMainTabbRoutePath} from 'src/modules/tabs-panel/tabs-route-planner';
import {TabId} from 'src/modules/tabs-panel/typedefs';
import {
    getAllChangeRequests,
    getChangeRequestCount,
    removeChangeRequestById,
    removeChangeRequestByIdFailure,
    removeChangeRequestByIdSuccess,
} from 'src/openapi/apis/ChangeRequestControllerApi';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {OnCloseNote, Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    id: number,
    code: string,
    source: string,
    onClose: OnCloseNote,
};

export const PushNotificationRemoveChangeRequest = ({id, code, source, onClose}: Props) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const {onCreateNote} = usePushNotification();

    const onClick = () => {
        dispatch(removeChangeRequestById({id})).then(e => {
            if (e.type === removeChangeRequestByIdSuccess.type) {
                onClose(`${id}`).then(() => {
                    if (!location.pathname.includes(TabId.CHANGE_REQUESTS)) {
                        const mainTabbRoutePath = createMainTabbRoutePath({pathName: TabId.CHANGE_REQUESTS});
                        navigate(mainTabbRoutePath);
                        return;
                    }
                    dispatch(getChangeRequestCount());
                    dispatch(getAllChangeRequests());
                });
            }

            if (e.payload.error && e.type === removeChangeRequestByIdFailure.type) {
                onCreateNote({
                    id: removeChangeRequestByIdFailure.type,
                    status: Status.ERROR,
                    message: e.payload.data.message,
                    buttonProps: {icon: Icons.CLOSE},
                    autoHideTimeout: 10000,
                });
            }
        });
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group direction="v" gap="s" style={{minWidth: '70%'}}>
                <Group gap="xs">
                    <Item shrink={0}>Delete change request for event code</Item>
                    <EllipsisTextHint bold={true}>{code}</EllipsisTextHint>
                </Group>
                <Group justify="start">
                    <Item>with source <strong>{source}</strong>?</Item>
                </Group>
            </Group>
            <FlatButton onClick={onClick}>Delete</FlatButton>
        </Group>
    );
};
